import React, {useEffect} from "react";
import styles from "../../../pages/dashboard/Dashboard.module.scss";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { Button, Loading } from '@onegovbugs/onegov-react-components';
import {
    organisationApplicantDetailsItems,
    interStateOrganisationDecisionDetailsItems,
    interStateOrganisationsLicenceDetailsItems
} from "utils/NavigationHelper";

import { renderSection } from '../../../utils/RenderHelper';
import ScrollToTop from "../../../utils/ScrollToTop";
import { RedirectIfCaptchaNotSelected } from "../../../utils/Redirect";
import {saveImportExportApplication, createApplication} from "../../../redux/actions";
import { Import_Export_Licence_Type} from '../../../constants';

const OrganisationDashboard = props => {

    ScrollToTop();
    RedirectIfCaptchaNotSelected(props);

    const dispatch = useDispatch();
    const application = useSelector((state) => state.application);
    const formData = useSelector((state) => state.form);
    const { form, formFetching } = formData;

    const organisationApplicationDetails = useSelector(state => state.organisationApplicationDetails);
    const importExportDetails = useSelector(state => state.importExportDetails);
    const interStateDetails = useSelector(state => state.interStateDetails);
    const speciesDetails = useSelector(state => state.speciesDetails);
    const disableContinue = (!organisationApplicationDetails.finished || !importExportDetails.interStateDecisionAppTypeFinished || !speciesDetails.finished);
        //|| !interStateDetails.finished || !speciesDetails.finished);

    useEffect(() => {
        if (!application.applicationNo) {     
            dispatch(createApplication((res) => {
                if(res)
                {
                    const newApplicationData = {
                        creatingApplication:false,
                        createdApplication:true,
                        applicationID:res.data.applicationId,
                        licenceType:null,
                        applicationNo:res.data.applicationNo,
                        applicationFulfilled:false,
                        storingAppPayment:false,
                        applicationFinished:false,
                        applicationId:res.data.applicationId,
                    }

                    dispatch(saveImportExportApplication("", () => {}, newApplicationData))
                }
            }, Import_Export_Licence_Type));
        }
    }, [application.applicationNo]);

    return !formFetching
        ? [
            <div className={"row"}>
                <div className={`col-12`}>
                    <div className={styles.backCont}>
                        <a
                            className={styles.back}
                            onClick={() => {
                                props.history.push(`/import-export`);
                            }}
                        >
                            &#x3C;&nbsp;Back
                        </a>
                    </div>
                </div>
                <div className={`col-12`}>
                    <h1 className={`${styles.mainFormTitle} ${styles.underlinedMain}`}>
                        Apply for an Import / Export Licence
                    </h1>
                </div>
            </div>,
            <div className={styles.mainCont}>
                <div className={"row"}>
                    <div className={`col-12`}>
                        <h2>Sections to complete</h2>
                        <p className={styles.mainDescription}>
                            Please use sections of the form below to complete your
                            application. You can complete your application in any order. You
                            can save and exit this form at any time and return to complete
                            it later.
                        </p>
                        {renderSection(
                            "Organisation details",
                            "Use this section to complete the details of the applicant for this licence",
                            `/import-export/organisation-licence-information`,
                            organisationApplicationDetails.finished,
                            organisationApplicationDetails.step,
                            organisationApplicantDetailsItems,
                            undefined,
                            props.history,
                            form,
                        )}
                        {renderSection(
                            "Interstate Person/Organisation",
                            "Use this section to complete the details of the Interstate Person/Organisation",
                            `/import-export/organisation-interstate-decision`,
                            importExportDetails.interStateDecisionAppTypeFinished,
                            importExportDetails.interStateDecisionAppTypeStep,
                            interStateOrganisationDecisionDetailsItems,
                            undefined,
                            props.history,
                            form,
                        )}
                        {/* {renderSection(
                            "Interstate Person/Organisation Details",
                            "",
                            `/import-export/interstate-organisation`,
                            interStateDetails.finished,
                            interStateDetails.step,
                            interStateOrganisationDetailsItems,
                            undefined,
                            props.history,
                            form,
                        )} */}
                        {renderSection(
                            "Interstate Licence Details",
                            "Use this section to complete the details of the Interstate Licence",
                            `/import-export/interstate-organisation-licence`,
                            speciesDetails.finished,
                            speciesDetails.step,
                            interStateOrganisationsLicenceDetailsItems,
                            undefined,
                            props.history,
                            form,
                        )}                                                                                    
                    </div>
                    <div className={`col-12`}>
                        <Button
                            disabled={disableContinue}
                            onClick={() => {
                                if (!disableContinue) {
                                    props.history.push(`/import-export/review-organisation-application`);
                                }
                            }}
                        >
                            Continue
                        </Button>
                        <Button
                            secondary
                            onClick={() => {
                                dispatch(
                                    saveImportExportApplication("", () => {
                                      // props.history.push(`../application-saved`);
                                      window.location.href = `${process.env.REACT_APP_BAU_URL}`;
                                    })
                                  );
                            }}
                        >
                            Save & exit application
                        </Button>
                    </div>
                </div>
            </div>,
        ]
        : [
            <div className={"col-12"}>
                <Loading
                    className={styles.loading}
                    label={"Loading..."}
                    type={"ajax"}
                />
            </div>,
        ];

  
};
  
  export default withRouter(props => <OrganisationDashboard {...props}/>);
  
